import React, { Component } from "react";
import IncentiveRegistration from './Registration';

class Incentive extends Component {   
    render() {
        return (
            <div className="film-page">
                <img src="/assets/images/eathdeck/incentive-top-banner.jpg" />
                <div className="row">
                    <div className="medium-12 columns">
                        <div className="about-us">
                            <h2 className="text-center">Incentive Award Program</h2>
                            <p className="text-center">
                                Tell us your story or story of your organization.
                            </p>
                            <p className="text-center">Or nominate someone, or an organization whose story you want to tell us because you believe we should enter them to receive a</p>
                            <p className="text-center">
                                <strong>$3000 Incentive Award to explore a collaboration with earthDECKS</strong>
                            </p>
                        </div>
                    </div>
                </div>
                <IncentiveRegistration />
                <img src="/assets/images/eathdeck/incentive-bottom-banner.jpg" />
            </div>
        )
    }
}

export default Incentive;



// WEBPACK FOOTER //
// ./components/Incentive/Incentive.js